// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"UploadImageForGlobalVS_UploadImageContainer__wqqYu","slideUp":"UploadImageForGlobalVS_slideUp__PtJVn"};